import { parseFenceMeta } from '@sohanscript/markdown/fence-meta';
import type { ReactNode } from 'react';

export type FileEntry = {
	path: string;
	name: string;
	language?: string;
	icon: string;
	node: ReactNode;
};

export function getCodeText(node: ReactNode): string {
	return String((node as any)?.props?.children?.props?.children ?? '').replace(
		/\n$/,
		'',
	);
}

export function parseFileEntries(
	children: ReactNode,
	options?: { requireFilename?: boolean },
): FileEntry[] {
	const arr = Array.isArray(children) ? children : [children];
	const out: FileEntry[] = [];
	for (const c of arr) {
		if (!c || typeof c !== 'object') continue;
		const preProps = (c as any).props ?? {};
		const codeProps = (c as any).props?.children?.props ?? {};
		// NOTE: fence metadata lives on the `pre` element; the `code` child only
		// carries the language class.
		const meta = parseFenceMeta({
			...codeProps,
			'data-meta': codeProps['data-meta'] ?? preProps['data-meta'],
			'data-filename': codeProps['data-filename'] ?? preProps['data-filename'],
			'data-code-title':
				codeProps['data-code-title'] ?? preProps['data-code-title'],
			'data-lang': codeProps['data-lang'] ?? preProps['data-lang'],
			'data-language':
				codeProps['data-language'] ?? preProps['data-language'] ?? '',
		});
		const filename = meta.filename;
		if (options?.requireFilename && !filename) continue;
		const language =
			/language-([\w#+-]+)/.exec(codeProps.className ?? '')?.[1] ??
			meta.language;
		const tabName = meta.name || filename;
		const path = tabName || filename || language || 'code';
		out.push({
			path,
			name: options?.requireFilename
				? (path.split('/').pop() ?? path)
				: tabName || filename || language || 'code',
			language,
			node: c,
			icon: meta.icon,
		});
	}
	return out;
}
